import React from 'react';
import { createStyles, FormControl, makeStyles, Theme, Typography } from '@material-ui/core';
import ReactQuill from 'react-quill';

import 'react-quill/dist/quill.snow.css';

interface HtmlFieldProps {
  onChange: (x: string, y: unknown) => void;
  label?: string;
  field?: string;
  value?: string;
  placeHolder?: string;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    form: {
      minWidth: '100%',
      marginBottom: theme.spacing(2),
    },
    label: {
      marginBottom: theme.spacing(1),
    },
    editor: {
      minHeight: 300,
      '& .quill': {
        backgroundColor: theme.palette.background.paper,
      },
      '& .ql-container': {
        minHeight: 300,
        borderBottomLeftRadius: 4,
        borderBottomRightRadius: 4,
      },
      '& .ql-editor': {
        minHeight: 300,
      },
    },
  })
);

const modules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ color: [] }, { background: [] }],
    [{ align: [] }],
    [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
    ['link'],
    ['clean'],
  ],
};

const formats = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'color',
  'background',
  'align',
  'list',
  'indent',
  'link',
];

const HtmlInputField: React.FC<HtmlFieldProps> = ({ onChange, label, value, placeHolder }) => {
  const classes = useStyles();

  const handleChange = (content: string, _delta: unknown, _source: string, editor: unknown): void => {
    onChange(content, editor);
  };

  return (
    <FormControl className={classes.form}>
      <Typography variant="subtitle1" className={classes.label}>
        <strong>{label}:</strong>
      </Typography>

      <div className={classes.editor}>
        <ReactQuill
          theme="snow"
          value={value ?? ''}
          onChange={handleChange}
          modules={modules}
          formats={formats}
          placeholder={placeHolder}
        />
      </div>
    </FormControl>
  );
};

export default HtmlInputField;
